import ResourceList from '../../resource/list';

const AssetsList = () => {

      return(
        <div>
          <ResourceList resource="animations" name="Animations"/>
        </div>
      )

}

export default AssetsList;